import fetchWrapper from "./fetchWrapper";
// import Router from 'next/router';
import { BehaviorSubject } from "rxjs";

const userSubject = new BehaviorSubject(
  process.browser && JSON.parse(localStorage.getItem("user"))
);

export const userService = {
  user: userSubject.asObservable(),
  get userValue() {
    return userSubject.value;
  },
  get userRoles() {
    const findRoles =
      userSubject?.value?.role?.length > 0
        ? String(userSubject?.value?.role).includes(",")
          ? userSubject?.value?.role.split(",")
          : Array(userSubject?.value?.role)
        : [];
    return findRoles.map((i) => Number(i));
  },
  logout,
};

function logout() {
  fetchWrapper
    .post("auth/logout")
    .then((response) => console.log(response))
    .catch((error) => console.log(error))
    .finally(() => {
      // remove user from local storage, publish null to user subscribers and redirect to login page
      localStorage.removeItem("AUTH");
      localStorage.removeItem("CORE_MODULE_AUTH");
      localStorage.removeItem("user");
      localStorage.removeItem("module_info");
      localStorage.removeItem("menu_list");
      localStorage.removeItem("module_list");
      localStorage.removeItem("uom_precision");
      localStorage.removeItem("default_password_check");
      localStorage.removeItem("prevPath");
      localStorage.clear();
      userSubject.next(null);
      // Router.push('/signin');
      // window.location.href = "/auth/login";
    });
}
